import React from 'react';
import { ToastContainerProps } from 'react-toastify';

import Styled from './AppToastContainer.styled';

export default function AppToastContainer(props: ToastContainerProps) {
    return <Styled.AppToastContainerWrap toastClassName="toastify-content" position="top-center" newestOnTop autoClose={3000} {...props} />;
}
